<template>
  <div>
    <Header v-if="RouterShow" />
    <div class="content_template">
      <keep-alive>
        <a-config-provider :locale="langNow">
          <router-view v-if="RouterShow"></router-view>
        </a-config-provider>
      </keep-alive>
    </div>
    <a-back-top ref="ScrollTop" />
    <Footer v-if="RouterShow"></Footer>
  </div>
</template>
<script>
import Header from "./header";
import Footer from "./footer";

import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import { myMixin } from "@/mixins/tool.js";
export default {
  name: "pc",
  components: {
    Header,
    Footer,
  },

  mixins: [myMixin],
  computed: {
    langNow() {
      console.log(localStorage.getItem("locale"));
      return this.zh_CN;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/PC/index.vue